import React from "react";

function LeadSection() {
  const features = [
    {
      title: "Fast setup",
      desc: "Live in weeks, not months.",
    },
    {
      title: "Works everywhere",
      desc: "Connects with 180+ payroll systems, including Workday.",
    },
    {
      title: "Bank-level security",
      desc: "Your data stays safe with comprehensive encryption and robust authentication.",
    },
    {
      title: "Always available",
      desc: "24/7 live agent support in multiple languages.",
    },
    {
      title: "No payroll changes",
      desc: "No new reconciliations, no chasing errors.",
    },
  ];

  return (
    <section
      className="
        bg-[#2d0707]

        py-16
        sm:py-20
        lg:py-20

        px-6
        sm:px-10
        lg:px-20
        h-[100%]
        md:h-[100%]
        lg:h-[500px]
      "
    >
      {/* TOP CONTENT */}
      <div
        className="
          max-w-[720px]
          lg:mt-[20px]
        "
      >
        <h2
          className="
            text-white
            ml-6
            lg:ml-[50px]

            text-[42px]
            sm:text-[56px]
            lg:text-[46px]
            lg:font-[900]

            leading-[0.95]
          "
        >
          Why We Lead On-Demand Pay
        </h2>

        <p
          className="
            mt-8
            md:mt-6
            lg:mt-6
            lg:ml-[40px]
            lg:font-[500]

            text-white/95

            text-[20px]
            sm:text-[24px]
            lg:text-[16px]

            leading-[1.5]
          "
        >
          DailyPay offers real financial wellness through instant
          access to earned pay. No <br /> hidden fees for employees —
          only a nominal fee for instant transfers. Proven <br />
          results for employers.
        </p>
      </div>

      {/* FEATURES */}
      {/* FEATURES */}
<div
  className="
    mt-20

    grid
    grid-cols-1
    sm:grid-cols-2

    lg:grid-cols-[1fr_1.2fr_1.2fr_1fr_1fr]

    gap-12
    sm:gap-14
    lg:gap-8
  "
>
        {features.map((item, index) => (
          <div key={index}>
            {/* ORANGE LINE */}
            <div
              className="
                w-[80px]
                h-[8px]

                bg-[#ff5a00]

                mb-8
                lg:-mt-8
                lg:ml-[50px]
              "
            />

            <h3
              className="
                text-white
                lg:ml-[50px]

                text-[28px]
                sm:text-[32px]
                md:text-[28px]
                lg:text-[19px]

                lg:font-serif

                leading-[1.1]
                lg:leading-[1.2]
              "
            >
              {item.title}
            </h3>

            <p
              className="
                mt-2
                lg:mt-4
                lg:ml-[50px]

                text-white/95

                text-[22px]
                md:text-[20px]
                lg:text-[17px]

                leading-[1.2]
                lg:leading-[1.4]
                font-sans
              "
            >
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default LeadSection;